import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { environment } from 'src/environments/environment';
import { MarginExpense } from '../../models/margin-expenses.model';
import { initialMarginExpensesSlice } from './margin-expenses.slice';
import { MarginExpenseType } from '../../models/margin-expense-type.model';

export const MarginExpensesStore = signalStore(
    { providedIn: 'root' },
    withState(initialMarginExpensesSlice),
    withMethods((store) => ({
        addMarginExpense: (marginExpense: MarginExpense) => {
            const marginExpenses = store.marginExpenses() ?? [];
            const doesMarginExpenseExist = marginExpenses.some(
                (e) => e.marginExpenseTypeId === marginExpense.marginExpenseTypeId
            );
            if (!doesMarginExpenseExist) {
                const updatedExpenses = [...marginExpenses, marginExpense];
                patchState(store, { marginExpenses: updatedExpenses });
            }
        },

        removeMarginExpense: (marginExpenseTypeId: number) => {
            const updatedMarginExpenses = store
                .marginExpenses()
                .filter((rate) => rate.marginExpenseTypeId !== marginExpenseTypeId);
            patchState(store, { marginExpenses: updatedMarginExpenses });
        },

        updateMarginExpenseField: (marginExpense: Partial<MarginExpense>) => {
            const updatedExpenses = store.marginExpenses().map((expense) => {
                if (
                    expense.marginExpenseTypeId === marginExpense.marginExpenseTypeId &&
                    expense.marginExpenseAttributesId === marginExpense.marginExpenseAttributesId
                ) {
                    return { ...expense, ...marginExpense };
                }
                return expense;
            });
            patchState(store, { marginExpenses: updatedExpenses });
        },

        loadMarginExpenseTypes: (marginExpenseTypes: MarginExpenseType[]) => {
            patchState(store, { marginExpenseTypes: marginExpenseTypes });
        },

        getState: () => store
    })),

    environment.storeWithDevTools('locums-margin-calculator-expenses-store')
);
